import _defineProperty from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/website-player/website-player/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { setInternalStateToActive } from '../helpers/set-internal-state-to-active';
import { setInternalStateToPassive } from '../helpers/set-internal-state-to-passive';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  detune: 0,
  frequency: 440,
  type: 'sine'
};
export var createOscillatorNodeConstructor = function createOscillatorNodeConstructor(audioNodeConstructor, createAudioParam, createInvalidStateError, createNativeOscillatorNode, createOscillatorNodeRenderer, getNativeContext, isNativeOfflineAudioContext, wrapEventListener) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(OscillatorNode, _audioNodeConstructor);

    var _super = _createSuper(OscillatorNode);

    function OscillatorNode(context) {
      var _this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

      _classCallCheck(this, OscillatorNode);

      var nativeContext = getNativeContext(context);

      var mergedOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

      var nativeOscillatorNode = createNativeOscillatorNode(nativeContext, mergedOptions);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var oscillatorNodeRenderer = isOffline ? createOscillatorNodeRenderer() : null;
      var nyquist = context.sampleRate / 2;
      _this = _super.call(this, context, false, nativeOscillatorNode, oscillatorNodeRenderer); // Bug #81: Edge, Firefox & Safari do not export the correct values for maxValue and minValue.

      _this._detune = createAudioParam(_assertThisInitialized(_this), isOffline, nativeOscillatorNode.detune, 153600, -153600); // Bug #76: Edge & Safari do not export the correct values for maxValue and minValue.

      _this._frequency = createAudioParam(_assertThisInitialized(_this), isOffline, nativeOscillatorNode.frequency, nyquist, -nyquist);
      _this._nativeOscillatorNode = nativeOscillatorNode;
      _this._onended = null;
      _this._oscillatorNodeRenderer = oscillatorNodeRenderer;

      if (_this._oscillatorNodeRenderer !== null && mergedOptions.periodicWave !== undefined) {
        _this._oscillatorNodeRenderer.periodicWave = mergedOptions.periodicWave;
      }

      return _this;
    }

    _createClass(OscillatorNode, [{
      key: "setPeriodicWave",
      value: function setPeriodicWave(periodicWave) {
        this._nativeOscillatorNode.setPeriodicWave(periodicWave);

        if (this._oscillatorNodeRenderer !== null) {
          this._oscillatorNodeRenderer.periodicWave = periodicWave;
        }
      }
    }, {
      key: "start",
      value: function start() {
        var _this2 = this;

        var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        this._nativeOscillatorNode.start(when);

        if (this._oscillatorNodeRenderer !== null) {
          this._oscillatorNodeRenderer.start = when;
        } else {
          setInternalStateToActive(this);

          var resetInternalStateToPassive = function resetInternalStateToPassive() {
            _this2._nativeOscillatorNode.removeEventListener('ended', resetInternalStateToPassive); // @todo Determine a meaningful delay instead of just using one second.


            setTimeout(function () {
              return setInternalStateToPassive(_this2);
            }, 1000);
          };

          this._nativeOscillatorNode.addEventListener('ended', resetInternalStateToPassive);
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        this._nativeOscillatorNode.stop(when);

        if (this._oscillatorNodeRenderer !== null) {
          this._oscillatorNodeRenderer.stop = when;
        }
      }
    }, {
      key: "detune",
      get: function get() {
        return this._detune;
      }
    }, {
      key: "frequency",
      get: function get() {
        return this._frequency;
      }
    }, {
      key: "onended",
      get: function get() {
        return this._onended;
      },
      set: function set(value) {
        var wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
        this._nativeOscillatorNode.onended = wrappedListener;
        var nativeOnEnded = this._nativeOscillatorNode.onended;
        this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
      }
    }, {
      key: "type",
      get: function get() {
        return this._nativeOscillatorNode.type;
      },
      set: function set(value) {
        this._nativeOscillatorNode.type = value; // Bug #57: Edge will not throw an error when assigning the type to 'custom'. But it still will change the value.

        if (value === 'custom') {
          throw createInvalidStateError();
        }

        if (this._oscillatorNodeRenderer !== null) {
          this._oscillatorNodeRenderer.periodicWave = null;
        }
      }
    }]);

    return OscillatorNode;
  }(audioNodeConstructor);
};